import {useLang} from '@/context/LanguageContext';
const english={
  "Standaardmeetinterval (ms)":"Default sampling interval (ms)",
  "Meetinterval (ms)":"Sampling interval (ms)",
  "Deze AIO-pilot gebruikt een meetinterval van 1000 ms. Korter is niet ondersteund. De lokale proef controleert de ingang vóór installatie.":"This AIO pilot uses a 1000 ms sampling interval. Shorter intervals are not supported. The local test checks the input before installation.",
"De automatische AIO-pilotcontrole ondersteunt één sensor. Kies het sensorprofiel en de fysieke ingang; de technische naam wordt later automatisch uitgelezen.":"The automatic AIO pilot inspection supports one sensor. Choose the sensor profile and physical input; its technical name is read automatically later.","Deze AIO-pilot leest eenmaal per seconde. Opslaan stelt 1 Hz in; de lokale proef controleert de ingang vóór installatie.":"This AIO pilot reads once per second. Saving sets 1 Hz; the local test checks the input before installation.","AIO-ingang":"AIO input","Ingang":"Input","Bestaande ingang · wordt later uitgelezen":"Existing input \u00b7 identified later","Fysieke AIO-inputmode":"Physical AIO input mode","Spanning · ongeschaalde mV → V":"Voltage · unscaled mV → V","Fysiek inputbereik in piCtory":"Physical input range in piCtory","Controleer de frequentie van verse proceswaarden op het apparaat. ADC 5 Hz betekent voorlopig maximaal 1 Hz acquisitie; een snellere softwarelus levert geen extra verse metingen.":"Verify the rate of fresh process values on the device. ADC 5 Hz provisionally permits at most 1 Hz acquisition; a faster software loop does not produce additional fresh measurements.","Waarde":"Value",
  "Alle installaties": "All installations",
  "Locatie niet ingesteld": "Location not set",
  "Verbonden": "Connected",
  "Vernieuwen": "Refresh",
  "Dit Pressure-device is aangemaakt. Rond de sensoren en inputmapping af in de installatiewizard.": "This Pressure device has been created. Complete its sensors and input mapping in the installation wizard.",
  "Kanalen": "Channels",
  "Virtuele kanalen": "Virtual channels",
  "Installatiewizard": "Installation wizard",
  "Boven werkdruk": "Above working pressure",
  "Geen meting": "No measurement",
  "Werkdruk": "Working pressure",
  "Wacht op eerste sample": "Waiting for the first sample",
  "Drukverloop": "Pressure trend",
  "Ingesteld": "Configured",
  "Hz · gemeten": "Hz · measured",
  "1 uur": "1 hour",
  "24 uur": "24 hours",
  "7 dagen": "7 days",
  "Begin": "From",
  "Eind": "To",
  " gem.": " avg.",
  "Lijn: gemiddelde · stippellijnen: minimum/maximum. Gaten blijven zichtbaar. Sleep om een eventinterval te selecteren.": "Line: average · dotted lines: minimum/maximum. Gaps remain visible. Drag to select an event interval.",
  "Gem.": "Avg.",
  "Afgeleide waarden": "Calculated values",
  "Aangenomen": "Assumed",
  "Nog geen berekeningen ingesteld.": "No calculations configured yet.",
  "Loggerstatus": "Logger status",
  "Configuratie: v": "Configuration: v",
  "nog niet bevestigd": "not confirmed yet",
  "Uploadwachtrij:": "Upload queue:",
  "Vrije opslag:": "Free storage:",
  "Klok:": "Clock:",
  "gesynchroniseerd": "synchronized",
  "niet bevestigd": "not confirmed",
  "nog niet verbonden": "not connected yet",
  "Periode": "Period",
  "Handmatig interval": "Manual interval",
  "Vervolgsegment": "Continuation segment",
  "Werkdruktrigger": "Working pressure trigger",
  "triggervermeldingen": "trigger entries",
  "Geen captures in deze periode.": "No captures in this period.",
  "Meer laden": "Load more",
  "Begin event": "Event start",
  "Eind event": "Event end",
  "Interval bewaren": "Save interval",
  "Eventdetails": "Event details",
  "nog open": "still open",
  "Ontbrekende voorgeschiedenis:": "Missing prehistory:",
  "s · configuratie v": "s · configuration v",
  "Vervolg van": "Continuation of",
  ". Oorspronkelijke triggers tellen niet als nieuwe overschrijding.": ". Original triggers do not count as a new exceedance.",
  "Heffen": "Lifting",
  "Dalen": "Lowering",
  "Rijden": "Driving",
  "Stilstand": "Idle",
  "Eigen label": "Custom label",
  "Notities": "Notes",
  "Label bewaren": "Save label",
  "Label bewaard.": "Label saved.",
  "Interval vastgelegd.": "Interval saved.",
  "Operation recognition, normal reference en deviation detection zijn niet beschikbaar. Basislogging blijft altijd actief.": "Operation recognition, normal reference and deviation detection are unavailable. Basic logging remains active.",
  "Een nieuwe apparaatsleutel maken? Een eerder geïnstalleerde logger moet daarna het nieuwe pakket krijgen.": "Create a new device key? An existing logger will then need the new package.",
  "Nieuwe sleutel gemaakt. Download nu het apparaatpakket.": "New key created. Download the device package now.",
  "Sla eerst een kanaalconfiguratie op.": "Save a channel configuration first.",
  "Gebruik het echte HTTPS-portaladres voor een RevPi.": "Use the actual HTTPS portal address for a RevPi.",
  "Vul alleen het portaladres zonder sleutels of parameters in.": "Enter only the portal address, without keys or parameters.",
  "Apparaatpakket gedownload. Het bevat de geheime apparaatsleutel.": "Device package downloaded. It contains the secret device key.",
  "Pressure installeren": "Install Pressure",
  "Van sensoren tot de eerste meetdata, binnen dezelfde installatie.": "From sensors to the first measurements, within the same installation.",
  "2 · Sensoren & kanalen": "2 · Sensors & channels",
  "3 · Installatiepakket": "3 · Installation package",
  "4 · Verbinding controleren": "4 · Check connection",
  "Hardware en aansluiting": "Hardware and wiring",
  "RevPi-model": "RevPi model",
  "Analoge module / artikelnummer": "Analog module / part number",
  "Eenheid van de inputwaarden": "Input value unit",
  "Inputmapping / bekabelingsnotities": "Input mapping / wiring notes",
  "Bekabeling, sensorvoeding en elektrische compatibiliteit met de inputmodule zijn gecontroleerd.": "Wiring, sensor supply and electrical compatibility with the input module have been verified.",
  "RevPi AIO wordt alleen lezend ondersteund na controle van de piCtory-configuratie, inputmapping en meetfrequentie. Zonder die gegevens blijft hardware-acquisitie geblokkeerd.": "RevPi AIO is supported for reading after verification of its piCtory configuration, input mapping and sample rate. Hardware acquisition stays blocked without this information.",
  "Geverifieerde RevPi AIO-mapping opnemen": "Include verified RevPi AIO mapping",
  "piCtory-configuratiepad": "piCtory configuration path",
  "SHA-256 van gecontroleerde piCtory-configuratie": "SHA-256 of verified piCtory configuration",
  "Geverifieerde maximale frequentie (Hz)": "Verified maximum sample rate (Hz)",
  "Controleverslag / referentie": "Verification report / reference",
  "Exacte AIO-modulenaam": "Exact AIO module name",
  "Statusinput per kanaal, gescheiden door komma": "Status inputs per channel, comma separated",
  "Controleer per ingang de werkelijke piCtory-mode, schaalinstellingen en driverunit. Het apparaat controleert dit opnieuw vóór acquisitie. De portal wijzigt de gedeelde hardwareconfiguratie niet.": "Verify the actual piCtory mode, scaling and driver unit for each input. The device checks these again before acquisition. The portal does not change the shared hardware configuration.",
  "Maak eerst kanalen in stap 2; keer daarna terug voor de fysieke inputcontrole.": "Create channels in step 2 first, then return to verify physical inputs.",
  "Sensorprofiel:": "Sensor profile:",
  "Selecteer na controle": "Select after verification",
  "Spanning 0–5 V · ongeschaalde mV → V": "Voltage 0–5 V · unscaled mV → V",
  "Stroom 4–20 mA · ongeschaalde µA → mA": "Current 4–20 mA · unscaled µA → mA",
  ": fysieke mode, inputbereik en ongeschaalde driverunit zijn gecontroleerd.": ": physical mode, input range and unscaled driver unit have been verified.",
  "Opslaan en verder": "Save and continue",
  "Koppeling en installatie": "Connection and installation",
  "Portaladres": "Portal address",
  "Meetmodus": "Measurement mode",
  "Echte hardware — inactief tot verificatie": "Real hardware — inactive until verified",
  "Simulator — uitsluitend testdata": "Simulator — test data only",
  "Apparaatsleutel gereed voor download.": "Device key ready for download.",
  "Nieuwe apparaatsleutel maken": "Create new device key",
  "Apparaatpakket downloaden": "Download device package",
  "Pressure-software downloaden": "Download Pressure software",
  "Pak de Pressure-software uit op de RevPi en zet het apparaatpakket in /tmp.": "Extract the Pressure software on the RevPi and place the device package in /tmp.",
  "Controleer het installatieplan:": "Check the installation plan:",
  "Installeer Pressure inactief in de eigen mappen:": "Install Pressure inactive in its own directories:",
  "De installer houdt Condition Monitor intact. Hardwarestart blijft geblokkeerd zolang er geen geverifieerde adapter is. Volg de meegeleverde handleiding voor de controle op het apparaat en het bewust starten van Pressure. Een nieuw pakket voor een bestaande, gestopte Pressure-installatie gebruikt --refresh-inactive in plaats van --install-inactive.": "The installer preserves Condition Monitor. Hardware startup stays blocked without a verified adapter. Follow the included manual to verify the device and start Pressure deliberately. A new package for an existing, stopped Pressure installation uses --refresh-inactive instead of --install-inactive.",
  "Naar verbindingscontrole": "Check connection",
  "Eerste gegevens controleren": "Check first data",
  "Eerste verbinding ontvangen": "First connection received",
  "Configuratie toegepast": "Configuration applied",
  "Eerste ruwe samples ontvangen": "First raw samples received",
  "Outbox zonder backlog": "Outbox without backlog",
  "Laatste receipt:": "Latest receipt:",
  "nog niet ontvangen": "not received yet",
  "Meetfrequentie: ingesteld": "Sample rate: configured",
  "Hz, gemeten": "Hz, measured",
  "Hz. Een simulatortest bewijst geen hardwarewerking.": "Hz. A simulator test does not prove hardware operation.",
  ". De sleutel wordt in het apparaatpakket opgenomen en niet in een installatieopdracht getoond.": ". The key is included in the device package and is not shown in an installation command.",
  "Sensorbibliotheek": "Sensor library",
  "Herbruikbare 4–20 mA- en 0,5–4,5 V-sensoren. Vul het drukbereik in volgens het sensortypeplaatje. Elke wijziging maakt een nieuwe revisie.": "Reusable 4–20 mA and 0.5–4.5 V sensors. Enter the pressure range from the sensor nameplate. Each change creates a new revision.",
  "bar · revisie": "bar · revision",
  "Nieuwe revisie": "New revision",
  "Nog geen sensorprofielen. Voeg hieronder de eerste sensor toe.": "No sensor profiles yet. Add the first sensor below.",
  "Nieuwe profielrevisie": "New profile revision",
  "Sensor toevoegen": "Add sensor",
  "Nieuw profiel": "New profile",
  "Elektrisch sensorsignaal": "Electrical sensor signal",
  "4–20 mA stroom": "4–20 mA current",
  "0,5–4,5 V spanning": "0.5–4.5 V voltage",
  "Fabrikant": "Manufacturer",
  "Model / artikelnummer": "Model / part number",
  "Standaardfrequentie (Hz)": "Default sample rate (Hz)",
  "Sensorrevisie bewaren": "Save sensor revision",
  "Sensorrevisie opgeslagen. Eerdere metingen blijven gelijk.": "Sensor revision saved. Historical measurements stay unchanged.",
  "Maak eerst een sensorprofiel aan.": "Create a sensor profile first.",
  "Druk ": "Pressure ",
  "Configuratie opgeslagen; de logger bevestigt toepassing bij synchronisatie.": "Configuration saved; the logger confirms application during synchronization.",
  "Fysieke drukkanalen": "Physical pressure channels",
  "Koppel 1–4 sensoren aan de werkelijke analoge ingangen.": "Connect 1–4 sensors to the actual analog inputs.",
  "Kanaal toevoegen": "Add channel",
  "Verwijderen": "Remove",
  "Kanaalnaam": "Channel name",
  "Fysieke input-ID": "Physical input ID",
  "Naam uit geverifieerde inputmapping": "Name from verified input mapping",
  "Sensor en revisie": "Sensor and revision",
  "Werkdruk (bar)": "Working pressure (bar)",
  "Acquisitie en capture": "Acquisition and capture",
  "Samples per seconde": "Samples per second",
  "Uploadinterval (seconden)": "Upload interval (seconds)",
  "Voor trigger (s)": "Before trigger (s)",
  "Na trigger (s)": "After trigger (s)",
  "Hysterese (bar)": "Hysteresis (bar)",
  "Alle raw-samples blijven behouden. Een geldige meting boven de werkdruk opent een capture voor alle kanalen. Kortere hardwaremeetintervallen vereisen verificatie.": "All raw samples are retained. A valid measurement above working pressure opens a capture for all channels. Higher hardware sample rates require verification.",
  "Configuratierevisie opslaan": "Save configuration revision",
  "Profiel beheren / Nieuw profiel": "Manage profile / New profile",
  "Virtuele kanalen opgeslagen.": "Virtual channels saved.",
  "Sla eerst de fysieke kanalen op.": "Save the physical channels first.",
  "Berekening toevoegen": "Add calculation",
  "Naam": "Name",
  "Berekening": "Calculation",
  "Aangenomen constante": "Assumed constant",
  "Bron van aanname": "Source of assumption",
  "Ideale waarden; geen wrijvingscorrectie. Alleen gelijktijdige geldige inputs worden gecombineerd.": "Ideal values; no friction correction. Only simultaneous valid inputs are combined.",
  "Berekening bewaren": "Save calculation",
  "Drukverschil": "Pressure difference",
  "Ideale cilinderkracht": "Ideal cylinder force",
  "Hydraulisch vermogen": "Hydraulic power",
  "Ideaal motorkoppel": "Ideal motor torque",
  "Motortoerental": "Motor speed",
  "Wielsnelheid": "Wheel speed",
  "Zuigerdiameter (mm)": "Piston diameter (mm)",
  "Stangdiameter (mm)": "Rod diameter (mm)",
  "Slagvolume (cm³/omw)": "Displacement (cm³/rev)",
  "Overbrengingsverhouding": "Gear ratio",
  "Wieldiameter (m)": "Wheel diameter (m)"
};
export function usePressureText(){const {t,lang}=useLang();return {pt:s=>t(s,english[s]||s),locale:lang==='en'?'en-GB':'nl-NL'};}
